module.exports = __webpack_public_path__ + "img/F981.3d73874c.jpg";